import { render } from "./StationListSkeleton.vue?vue&type=template&id=335109b2&scoped=true"
const script = {}

import "./StationListSkeleton.vue?vue&type=style&index=0&id=335109b2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335109b2"]])

export default __exports__